import TriggerTemplateRule from './TriggerTemplateRule';

export default TriggerTemplateRule;
